import React from 'react';
import { Tag, Typography } from 'antd';
import CopyText from '../components/CopyText';

const { Text } = Typography;

export const kioskTables = () => [
    {
        title: "Sr. No.",
        key: 'serial_no',
        className: 'col-index',
        width: 80,
        responsive: ['sm'],
        render: (item, record, index) => <Text>{index+1}</Text>
    },
    {
        title: 'Name',
        key: 'kiosk_id',
        dataIndex: 'kiosk_id',
        className: 'col-mono',
        render: (item) => <CopyText value={item} />,
    },
    {
        title: 'Online',
        key: 'is_online',
        dataIndex: 'is_online',
        render: (is_online) => (
            <Tag color={is_online === true ? 'success' : 'error'}>
                {is_online === true ? 'Yes' : 'No'}
            </Tag>
        )
    },
    {
        title: "Linked",
        key: 'is_linked',
        dataIndex: 'is_linked',
        render: (is_linked) => (
            <Tag color={is_linked === true ? 'processing' : 'default'}>
                {is_linked === true ? 'Yes' : 'No'}
            </Tag>
        )
    },
].filter((item) => !item.hidden);
